export default "__VITE_ASSET__Ddc1_Z5T__"